import { eventSource } from './eventSource'
const baseURL = '/api-gateway/jpaas-jagent-server/interfaces'

const api = {
  ask: baseURL + '/component/ask'
}
export const sseAPI = {
  ask (data) {
    return eventSource({
      method: 'POST',
      url: api.ask,
      data: data.data,
      message: data.message
    })
  }
}
